import { render, staticRenderFns } from "./MotorsportCalendarPage.vue?vue&type=template&id=39e51736"
import script from "./MotorsportCalendarPage.vue?vue&type=script&lang=ts"
export * from "./MotorsportCalendarPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports